import { AxiosResponse } from 'axios';

import { QueryObserverOptions, useQueryClient } from '@tanstack/react-query';
import { toastService } from '@thefarmersfront/kitchen-mobile';

import { useCodesStore } from '../../store';
import { TypeCodeState } from '../../types';
import { axiosInstance } from '~/services/fetchServiceV2';
import { TypeErrorFormat, requestHelper } from '~/utils/fetchHelper';

type TypeGetAllCenterCodesResponse = {
  code: string;
  message: string;
  data: {
    center: TypeCodeState[];
  };
};

/** @description 모든 센터 코드 조회 */
export const useGetAllCenterCodes = () => {
  const queryClient = useQueryClient();

  const { setCenterCodes } = useCodesStore((state) => state.actions);

  const handleSuccess = (response: TypeGetAllCenterCodesResponse) => {
    setCenterCodes(response?.data?.center ?? []);
  };

  const handleError = (error: TypeErrorFormat) => {
    toastService.addToast({ message: error.message });
    setCenterCodes(null);
  };

  const requestGetAllCenterCodes = async ({
    queryConfig,
  }: {
    queryConfig?: Omit<QueryObserverOptions<AxiosResponse<TypeGetAllCenterCodesResponse>>, 'queryKey' | 'queryFn'>;
  } = {}) => {
    const endpoint = '/codes/center';
    const query = queryClient.ensureQueryData<AxiosResponse<TypeGetAllCenterCodesResponse>>({
      queryKey: ['codes', 'center'],
      queryFn: () => axiosInstance.get<TypeGetAllCenterCodesResponse>(endpoint),
      ...queryConfig,
      gcTime: 0,
    });

    return requestHelper(() => query, handleSuccess, handleError);
  };

  return requestGetAllCenterCodes;
};
